import { createApiSlice } from "@common/common-slice/commonSlice";
import { timeoutCall } from "@pionglobal/pionsharedui";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { downloadExcelFile } from "@helper";

import {
  CRUD_SKILL_ASSESSMENT_ASSESSOR,
  UPLOAD_USER,
  DOWNLOAD_USER,
  GET_ALERT_DELETE_ASSESSOR,
  GET_SKILL_ASSESSMENT_ASSESSOR,
  GET_SKILL_ASSESSMENT_ASSESSOR_BY_ID
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addSkillAssessmentAssessor",
    method: "post",
    url: CRUD_SKILL_ASSESSMENT_ASSESSOR,
    stateKey: "message",
  },
  {
    name: "getSkillAssessmentAssessor",
    method: "get",
    url: GET_SKILL_ASSESSMENT_ASSESSOR,
    stateKey: "data",
  },
  {
    name: "getAlertDeleteAssessor",
    method: "get",
    url: GET_ALERT_DELETE_ASSESSOR,
    stateKey: "alertDeleteAssessor",
  },
  {
    name: "getSkillAssessmentAssessorById",
    method: "post",
    url: GET_SKILL_ASSESSMENT_ASSESSOR_BY_ID,
    stateKey: "data",
  },
  {
    name: "updateSkillAssessmentAssessor",
    method: "put",
    url: CRUD_SKILL_ASSESSMENT_ASSESSOR,
    stateKey: "message",
  },
  {
    name: "deleteSkillAssessmentAssessor",
    method: "delete",
    url: CRUD_SKILL_ASSESSMENT_ASSESSOR,
    stateKey: "message",
  },
];

export const downloadUser =
  createAsyncThunk("assessmentAssessor/downloadUser",
    async (
      data,
      { rejectWithValue, dispatch },
    ) => {
  return downloadExcelFile({
        url: DOWNLOAD_USER,
        params: data,
        fileName: "ParticipantDownloadTemplate.xlsx",
        dispatch,
        rejectWithValue,
        resetFunction,
      });
    }
  );

export const uploadUser = createAsyncThunk(
  "questionBank/uploadUser",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(UPLOAD_USER, data, {
        withCredentials: true,
      });
      resetFunction(dispatch);
      return response;
    } catch (err) {
      resetFunction(dispatch);
      return rejectWithValue(err.response.data);
    }
  }
);

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    genData: [],
    alertData: [],
    details: [],
    assessor_response: [],
    alertDeleteAssessor: [],
  },
  reducers: {
  },
};

const { slice, thunks, actions } = createApiSlice(
  "skillAssessmentAssessor",
  apiConfig,
  customReducers
);
const skillAssessmentAssessorSlice = slice;

export default skillAssessmentAssessorSlice.reducer;

export const actionsExports = actions;

export const {
  addSkillAssessmentAssessor,
  getSkillAssessmentAssessor,
  getAlertDeleteAssessor,
  getSkillAssessmentAssessorById,
  updateSkillAssessmentAssessor,
  deleteSkillAssessmentAssessor,
} = thunks;

export const { rowSelect,resetErrMessage,resetMessage } =
  actionsExports;

  const resetFunction = (dispatch) => {
  timeoutCall(() => {
    dispatch(resetMessage());
    dispatch(resetErrMessage());
  });
};